
import { callApi} from '../../lib/SwaggerApi';

export const GET_CAPACITY_TERMINALS = {
  REQUEST: "GET_CAPACITY_TERMINALS_REQUEST",
  SUCCESS: "GET_CAPACITY_TERMINALS_SUCCESS",
  FAILURE: "GET_CAPACITY_TERMINALS_FAILURE"
};

export function getCapacityTerminals(callback) {
  return callApi(null, "Capacity", "getCapacityTerminals", GET_CAPACITY_TERMINALS, callback);
}





// WEBPACK FOOTER //
// ./src/containers/Capacity/CapacityActions.js